import { StyledTabPanel } from "@/includes";
import { TabContext, TabList } from "@mui/lab";
import { Box, Tab, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabsTemplateProps } from "./types";

const TabsTemplate = ({
  tabs,
  children,
  afterChangeTabs,
  vertical = false,
}: TabsTemplateProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [tabValue, setTabValue] = useState<any>(tabs[0]);
  const handleChangeTab = (
    event: React.SyntheticEvent | null,
    newValue: any
  ) => {
    setTabValue(newValue);
    if (!!afterChangeTabs) afterChangeTabs(newValue);
  };
  return (
    <TabContext value={tabValue}>
      <Box
        sx={{
          flexGrow: 1,
          width: 1,
          display: "flex",
          flexDirection: vertical ? "row" : "column",
          height: 1,
          alignItems: "start",
          gap: vertical ? 2 : 0,
        }}
      >
        <TabList
          scrollButtons
          allowScrollButtonsMobile
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.customPalette.bluePurple.dark,
            },
          }}
          onChange={handleChangeTab}
          orientation={vertical ? "vertical" : "horizontal"}
          sx={{
            mb: 2,
            "& .MuiButtonBase-root": {
              alignItems: "center",
              boxShadow: "2px 2px 12px 0px rgba(0, 0, 0, 0.06)",
              p: 1,
              borderRadius: 1,
              fontSize: 14,
              textTransform: "none",
              minHeight: 0,
              backgroundColor: theme.customPalette.grey.white,
              "&.Mui-selected": {
                backgroundColor: theme.customPalette.bluePurple.lighter,
                color: theme.customPalette.bluePurple.main,
              },
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
            "& .MuiTabs-scroller": {
              display: "flex",
              alignItems: "flex-end",
              overflow: "visible !important",
              "& .MuiTabs-flexContainer": {
                gap: 1,
              },
            },
            overflow: "visible",
          }}
        >
          {tabs?.map((tab: string) => (
            <Tab
              key={tab}
              label={t(`${tab?.toLowerCase()}_tab`)}
              value={tab}
              data-testid={`${tab}-tab`}
            />
          ))}
        </TabList>
        {tabs?.map((tab: string, index: number) => (
          <StyledTabPanel
            value={tab}
            data-testid={`${tab}-tab-panel`}
            sx={{
              height: 1,
              flex: 1,
              width: vertical ? "calc(100% - 128px)" : 1,
            }}
          >
            {children[index]}
          </StyledTabPanel>
        ))}
      </Box>
    </TabContext>
  );
};

export default TabsTemplate;
